import { action } from "../common/Action"
import { TechniciansClient, TechnicianData, TechnicianDto } from "../generated";

const service = new TechniciansClient();

class TechiniciansActions {
    @action
    async add(technician: TechnicianData) {
        const id = await service.add(technician);
        const result = new TechnicianDto();
        result.init({ ...technician, id } as TechnicianDto)
        return result;
    }
    @action
    async update(id: number, technician: TechnicianData) {
        await service.update(technician, id);
        const result = new TechnicianDto();
        result.init({ ...technician, id } as TechnicianDto)
        return result;
    }
    @action
    async getAll() {
        return (await service.getAll())!;
    };
}
export default new TechiniciansActions();